(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["r9-card-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    function galleryImgs(card) {
      // primeira imagem de cada slide do card-gallery (a visível é a 1ª)
      return card.querySelectorAll('.card-gallery img');
    }
    function swap(card, url) {
      galleryImgs(card).forEach(function (img, idx) {
        if (idx > 0) return; // só a imagem principal do card
        if (!img.getAttribute('data-r9-orig')) {
          img.setAttribute('data-r9-orig', img.getAttribute('src') || '');
          img.setAttribute('data-r9-orig-srcset', img.getAttribute('srcset') || '');
        }
        img.removeAttribute('srcset');
        img.src = url;
      });
    }
    function restore(card) {
      galleryImgs(card).forEach(function (img, idx) {
        if (idx > 0) return;
        var orig = img.getAttribute('data-r9-orig');
        if (!orig) return;
        img.src = orig;
        var ss = img.getAttribute('data-r9-orig-srcset');
        if (ss) img.setAttribute('srcset', ss);
      });
    }
    function initRail(rail) {
      if (rail.hasAttribute('data-r9-init')) return;
      rail.setAttribute('data-r9-init', '1');
      var card = rail.closest('product-card') || rail.closest('.product-card');
      if (!card) return;
      rail.addEventListener('mouseover', function (ev) {
        var chip = ev.target.closest('[data-r9-cs-img]');
        if (!chip) return;
        swap(card, chip.getAttribute('data-r9-cs-img'));
        // prefetch da PDP no hover: clique abre quase instantâneo
        if (!chip.hasAttribute('data-r9-pf')) {
          chip.setAttribute('data-r9-pf', '1');
          var l = document.createElement('link');
          l.rel = 'prefetch';
          l.href = chip.getAttribute('href');
          document.head.appendChild(l);
        }
      });
      rail.addEventListener('mouseleave', function () { restore(card); });
      // clique navega naturalmente pelo href (?variant= já embutido)
    }
    function initAll(root) {
      (root || document).querySelectorAll('[data-r9-card-swatches]:not([data-r9-init])').forEach(initRail);
    }
    initAll(document);
    // cards que chegam depois (filtros da coleção, busca, recomendações via Section Rendering)
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if (n.matches && n.matches('[data-r9-card-swatches]')) initRail(n);
            initAll(n);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
